export const CLOSE_DIALOG_INVITE_USER_INFO = 'lumahealth/DialogUserInvitationsInfo/CLOSE_DIALOG_INVITE_USER_INFO';

export const OPEN_DIALOG_INVITE_USER_INFO = 'lumahealth/DialogUserInvitationsInfo/OPEN_DIALOG_INVITE_USER_INFO';

export const RESEND_USER_INVITE = 'lumahealth/DialogUserInvitationsInfo/RESEND_USER_INVITE';
export const RESEND_USER_INVITE_SUCCESS = 'lumahealth/DialogUserInvitationsInfo/RESEND_USER_INVITE_SUCCESS';
export const RESEND_USER_INVITE_ERROR = 'lumahealth/DialogUserInvitationsInfo/RESEND_USER_INVITE_ERROR';

export const RESEND_USER_INVITES = 'lumahealth/DialogUserInvitationsInfo/RESEND_USER_INVITES';
export const RESEND_USER_INVITES_SUCCESS = 'lumahealth/DialogUserInvitationsInfo/RESEND_USER_INVITES_SUCCESS';
export const RESEND_USER_INVITES_ERROR = 'lumahealth/DialogUserInvitationsInfo/RESEND_USER_INVITES_ERROR';
